// components/Editor.jsx
import React, { useMemo } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';

// Register modules
Quill.register('modules/imageResize', ImageResize);

// Optional: add custom classes for alignment
const AlignClass = Quill.import('attributors/class/align');
Quill.register(AlignClass, true);

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['link', 'image'],
    ['clean']
  ],
  imageResize: {
    modules: ['Resize', 'DisplaySize']
  }
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet', 'indent',
  'align',
  'link', 'image'
];

export default function Editor({ value, setValue, toolbar = true, readOnly = false }) {
  return (
    <div className="border rounded bg-white shadow p-2">
      <ReactQuill
        value={value}
        onChange={setValue}
        modules={toolbar ? modules : { toolbar: false }}
        formats={formats}
        readOnly={readOnly}
        className="min-h-[300px]"
        placeholder="Write your blog content here..."
      />
    </div>
  );
}
